export default "__VITE_ASSET__QLZ5zTZF__"